<template>
    <ValidationObserver ref="validationObserver" v-slot="{ invalid }">
        <BaseModalFront
            data-testid="edit-ticket-modal"
            :show="show"
            :title="$t('perfil.cambiar_datos')"
            :confirm-text="$t('perfil.guardar')"
            :cancel-text="$t('perfil.cancelar')"
            confirm-variant="alt"
            :confirm-disabled="!isValid || loading || invalid"
            confirm-test-id="edit-ticket-btn-guardar"
            cancel-test-id="edit-ticket-btn-cancelar"
            @close="handleClose"
            @confirm="handleSubmit"
        >

            <div class="tw:space-y-4">
                <div class="tw:grid tw:grid-cols-2 tw:gap-3">
                    <InputText
                        data-testid="edit-ticket-input-nombre"
                        :value="nombre"
                        :label="$t('formularios.nombre')"
                        name="nombre"
                        rules="required"
                        :disabled="loading"
                        @input="nombre = $event"
                    />
                    <InputText
                        data-testid="edit-ticket-input-apellidos"
                        :value="apellidos"
                        :label="$t('formularios.apellidos')"
                        name="apellidos"
                        rules="required"
                        :disabled="loading"
                        @input="apellidos = $event"
                    />
                </div>
                <div class="tw:flex tw:items-start tw:gap-2">
                    <div class="tw:w-1/2 tw:shrink-0">
                        <DocumentType
                            :value="tipoDoc"
                            :disabled="loading"
                            @input="tipoDoc = $event"
                        />
                    </div>
                    <div class="tw:flex-1 tw:min-w-0">
                        <DocumentValue
                            data-testid="edit-ticket-input-dni"
                            :value="dni"
                            :type="tipoDoc"
                            :disabled="loading"
                            @input="dni = $event"
                        />
                    </div>
                </div>
            </div>

            <p v-if="error" class="tw:text-xs tw:text-red-600 tw:font-medium tw:m-0 tw:mt-3">{{ error }}</p>
        </BaseModalFront>
    </ValidationObserver>
</template>

<script setup>
    import { watch } from 'vue';
    import BaseModalFront from '@/modules/front/ui/BaseModalFront.vue';
    import InputText from '@/modules/front/ui/InputText.vue';
    import DocumentType from '@/modules/front/ui/DocumentType.vue';
    import DocumentValue from '@/modules/front/ui/DocumentValue.vue';
    import { useEditTicket } from '@/composables/front/perfil/useEditTicket';
    import { useToast } from '@/composables/common/useToast';
    import { t } from '@/utils/i18n-helper';

    const props = defineProps({
        show:     { type: Boolean, required: true },
        entrada:  { type: Object,  required: true },
        pedidoId: { type: [Number, String], default: null },
        todasEntradas: { type: Array, default: () => [] },
    });
    const emit = defineEmits(['close', 'success']);

    const { nombre, apellidos, tipoDoc, dni, isValid, loading, error, init, reset, update, validateDuplicateDni } = useEditTicket();
    const toast = useToast();

    const handleSubmit = async() => {
        const dupKey = validateDuplicateDni(dni.value?.trim(), props.entrada.id, props.todasEntradas);
        if (dupKey) {
            error.value = t(dupKey);
            return;
        }

        const ok = await update(props.entrada, props.pedidoId);
        if (ok) {
            toast.success(t('perfil.datos_editados'));
            emit('success', { nombre: nombre.value, apellidos: apellidos.value, dni: dni.value });
            emit('close');
        }
    };

    const handleClose = () => {
        if (!loading.value) {
            reset();
            emit('close');
        }
    };

    watch(() => props.show, val => {
        if (val) init(props.entrada);
        else reset();
    });
</script>
